import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=65d1940d&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=ts&"
export * from "./MediaUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=65d1940d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1940d",
  null
  
)

export default component.exports